export default __webpack_public_path__ + "static/media/icon-metrics-water-flow-rate.74b0bc0d.svg";